/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import uuid from "react-uuid";

import {
  failureAction,
  onEntryAction,
  onErrorAction,
  onExitAction,
  resetAction,
  successAction,
  AppServiceMachineConfig,
} from "../../../state-machine";
import {
  checkIfDataChanged,
  getCalloutQueue,
  formatQueueHeaderData,
  getNormalUserList,
  getVIPUserList,
  updateCurrentQueueStore,
} from "./states";

const PROCESS_PAYMENT_Q_RESPONSE: AppServiceMachineConfig = {
  id: "process.payment.q.response",
  initial: "IDLE",
  predictableActionArguments: true,
  context: {},
  states: {
    IDLE: {
      on: {
        START: {
          target: "CHECK_IF_DATA_CHANGED",
          actions: [successAction],
        },
      },
    },
    CHECK_IF_DATA_CHANGED: {
      invoke: {
        id: "checkIfDataChanged",
        src: checkIfDataChanged,
        onDone: {
          target: "FORMAT_QUEUE_HEADER_DATA",
          actions: [successAction],
        },
        onError: {
          target: "END",
          actions: [failureAction],
        },
      },
    },
    FORMAT_QUEUE_HEADER_DATA: {
      invoke: {
        id: "formatQueueHeaderData",
        src: formatQueueHeaderData,
        onDone: {
          target: "GET_CALLOUT_QUEUE",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    GET_CALLOUT_QUEUE: {
      invoke: {
        id: "getCalloutQueue",
        src: getCalloutQueue,
        onDone: {
          target: "GET_NORMAL_USER_LIST",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    GET_NORMAL_USER_LIST: {
      invoke: {
        id: "getNormalUserList",
        src: getNormalUserList,
        onDone: {
          target: "GET_VIP_USER_LIST",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    GET_VIP_USER_LIST: {
      invoke: {
        id: "getVIPUserList",
        src: getVIPUserList,
        onDone: {
          target: "UPDATE_CURRENT_QUEUE_STORE",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    UPDATE_CURRENT_QUEUE_STORE: {
      invoke: {
        id: "updateCurrentQueueStore",
        src: updateCurrentQueueStore,
        onDone: {
          target: "END",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    END: {
      type: "final",
    },
    ERROR: {
      type: "final",
    },
  },
  extendContextWith: function (extContext: any) {
    //@ts-ignore
    this.id = uuid();
    this.context = { ...this.context, ...extContext };
    return this;
  },
};
export { PROCESS_PAYMENT_Q_RESPONSE };
